import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppelsService } from 'src/app/modules/appels/service/appels.service';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.css'],
})
export class ConfirmationComponent implements OnInit {
  @ViewChild('toggleButton') toggleButton!: ElementRef;
  @ViewChild('toggleButton2') toggleButton2!: ElementRef;

  iufApplicant!: String;
  activatedRoute!: ActivatedRoute;
  cohorte!: string;

  showSpinner = false;

  confirmed = false;
  noconfirmed = false;

  // showDialog = true;

  constructor(
    private appelsService: AppelsService,
    private route: ActivatedRoute,
    private spinnerService: SpinnerServiceService
  ) {
    this.spinnerService.hideSpinner();
    /* this.spinnerService.spinner$.subscribe((data: boolean) => {
        setTimeout(() => {
          this.showSpinner = data ? data : false;
        });
      }); */
  }

  ngOnInit(): void {
    //Recuperation de l'iuf depuis l'url
    this.spinnerService.hideSpinner();

    this.iufApplicant = this.route.snapshot.params['iuf'];
    this.cohorte = this.route.snapshot.params['cohorte'];
    // console.log(this.iufApplicant);

    if (this.iufApplicant && this.cohorte) {
      this.appelsService
        .checkAdmission(this.iufApplicant, this.cohorte)
        .subscribe((response) => {
          if (response == null) {
            setTimeout(() => {
              this.confirmed = true;
            });
          } else if (response.status === 200 || response.status === 201) {
            setTimeout(() => {
              this.noconfirmed = true;
            });
          }
        });
    }
  }
}
